import { render, staticRenderFns } from "./Gene.vue?vue&type=template&id=4c1b302c"
import script from "./Gene.vue?vue&type=script&lang=js"
export * from "./Gene.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports